import { createContext } from 'react';

/**
 * True when the mockup sits in the mobile Studio, which magnifies and frames
 * it itself (OnboardingMobileStudio's `focus`): ZoomedIPhoneMockup then stays
 * at rest instead of adding its desktop zoom on top.
 */
export const MockupFramedByCanvasContext = createContext(false);
